export default __webpack_public_path__ + "static/media/vitejs.11f3d899.svg";